module.exports = __webpack_public_path__ + "static/media/warning.3bc6bf8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/common/music/warning.mp3
// module id = LfG/
// module chunks = 84